import {
  computed,
  unref,
  type MaybeRef,
  type Ref,
} from 'vue';

import {
  useFileContentServicesQuery as useQuery,
  type FileContentServiceFragmentFragment as Fragment,
  type FileContentServicesQueryVariables as Variables,
} from '@/graphql/generated/graphql';
import useTableSearchOrder from '@/ui/Table/useTableRouter/seachOrder/useTableSearchOrder';

const useFileContentServicesSearch = (
  fileId: Ref<number>,
  setURL?: boolean,
  forceVariables?: MaybeRef<Partial<Variables> | undefined>,
) => {
  const {
    query, setQuery, search, setSearch,
  } = useTableSearchOrder<keyof Fragment, Record<string, never>>(setURL);

  const variables = computed<Variables>(() => {
    const { search: _querySearch, ...rest } = query.value;
    const forced = unref(forceVariables);
    return {
      ...rest,
      ...forced,
      file_id: fileId.value,
    };
  });

  const result = useQuery({ variables });

  const data = computed(() => result.data.value?.fileContentServices);

  return {
    data,
    fetching: result.fetching,
    error: result.error,
    refetch: () => result.executeQuery({ requestPolicy: 'network-only' }),
    query,
    setQuery,
    search,
    setSearch,
    variables,
  };
};

export default useFileContentServicesSearch;
